import { Component } from '@angular/core';
import { WrapHeaderActionEnum } from '../../interfaces/header.model';
import { BaseComponent } from '../base/base.component';


@Component({
  selector: 'cargoes-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.less'],
})
export class HeaderComponent extends BaseComponent {
  headerEnum = WrapHeaderActionEnum;

  onAction(action: WrapHeaderActionEnum, data?: any) {
    this.action.emit({ action, data });
  }
}
